import { render, staticRenderFns } from "./yek-koulutuksen-edistyminen-card.vue?vue&type=template&id=0af12a5b&scoped=true&"
import script from "./yek-koulutuksen-edistyminen-card.vue?vue&type=script&lang=ts&"
export * from "./yek-koulutuksen-edistyminen-card.vue?vue&type=script&lang=ts&"
import style0 from "./yek-koulutuksen-edistyminen-card.vue?vue&type=style&index=0&id=0af12a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af12a5b",
  null
  
)

export default component.exports